import Orders from './modules/Orders'
import Envelopes from './modules/Envelopes';
import Bills from './modules/Bills';
import Deposits from './modules/Deposits'
import Checks from './modules/Checks'
import RenoveExports from './modules/RenoveExports';
import ReturnedChecks from './modules/ReturnedChecks'
import Exchanges from './modules/Exchanges'
import Pix from './modules/Pix';
import PayShipping from './modules/PayShippingRoutes'
import IncomeExtracts from './modules/IncomeExtracts';
import PeriodicConsolidations from "@/_backoffice/_financial/router/modules/PeriodicConsolidations.js"
import ClientBonusRoutes from './modules/ClientBonusRoutes';
import FinancialConsolidatedReports from "./modules/FinancialConsolidatedReports";
import SellerComissionConfigRoutes from "./modules/SellerComissionConfigRoutes";


export default [
  ...Orders,
  ...Envelopes,
  ...Bills,
  ...Deposits,
  ...Checks,
  ...RenoveExports,
  ...ReturnedChecks,
  ...Exchanges,
  ...Pix,
  ...PayShipping,
  ...IncomeExtracts,
  ...PeriodicConsolidations,
  ...ClientBonusRoutes,
  ...FinancialConsolidatedReports,
  ...SellerComissionConfigRoutes,
]

